import React from 'react';
import 'components/ui/title_action_header/styles.scss';

const TitleActionHeader = ({ children, className, rest }) => (
  <div className={ `title-action-header ${className || ''}` } { ...rest }>{ children }</div>
);

export default TitleActionHeader;
